export default __webpack_public_path__ + "static/2000_2010-e93c2701b072af484739ddf242ccc3c2.jpg";